// Typelizer digest 2a258bbe8149fcbc196591637a8fd12c
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** GET /learners/schools/:school_id/relief_listings/:relief_listing_id/requests */
  index: (
    params: { schoolId: string | number; reliefListingId: string | number },
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/learners/schools/:school_id/relief_listings/:relief_listing_id/requests', params, options),
    method: 'get',
  }),
}
